export function getVisibleAdUnits() {
  const elements = document.querySelectorAll<HTMLElement>('display-ad-component');
  const viewabilityPercentThreshold = 0.5;

  return Array.from(elements).filter((el) => {
    const win = globalThis;

    if (!el) return false;
    if (!el.parentElement) return false;
    if (el.style.display === 'none') return false;

    const bounds = el.getBoundingClientRect();

    const visibleHeight = Math.min(win.innerHeight, bounds.bottom) - Math.max(0, bounds.top);
    const visibleWidth = Math.min(win.innerWidth, bounds.right) - Math.max(0, bounds.left);
    const visibleArea = Math.max(0, visibleHeight) * Math.max(0, visibleWidth);
    const totalArea = bounds.width * bounds.height;
    const visibilityPercent = totalArea > 0 ? (visibleArea / totalArea) : 0;

    return visibilityPercent >= viewabilityPercentThreshold;
  });
}
